import React, { useEffect } from 'react'
import {Titulo} from 'asocomponents'
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'
import DetalleJuicioContainer from '../../components/organismos/DetalleJuicioContainer/DetalleJuicioContainer'

function DetalleJuicio() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Detalle del Juicio"/>
      <DetalleJuicioContainer />
    </Layout>
  )
}

export default DetalleJuicio
